import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AuthGuard } from './auth/AuthGuard';
import { FeedbackEntry } from './ui/FeedbackEntry';
import { useAuth } from './state/auth';
import Login from './routes/Login';
import AdminLogin from './routes/AdminLogin';
import Board from './routes/Board';
import Admin from './routes/Admin';

function DefaultBoardRedirect() {
  const token = useAuth((s) => s.token);
  const nav = useNavigate();
  const [state, setState] = useState<'loading' | 'no_default' | 'error'>('loading');

  useEffect(() => {
    if (!token) return;
    fetch('/api/boards/default', { headers: { authorization: `Bearer ${token}` } })
      .then(async (r) => {
        if (r.ok) {
          const b = await r.json();
          nav(`/b/${b.slug}`, { replace: true });
        } else if (r.status === 404) {
          setState('no_default');
        } else {
          setState('error');
        }
      })
      .catch(() => setState('error'));
  }, [token, nav]);

  if (state === 'loading')
    return (
      <div className="h-full w-full flex flex-col items-center justify-center gap-3 bg-neutral-900 text-white/80">
        <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden>
          <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeOpacity=".25" strokeWidth="3" />
          <path d="M21 12a9 9 0 00-9-9" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
            <animateTransform attributeName="transform" type="rotate" dur="0.9s" from="0 12 12" to="360 12 12" repeatCount="indefinite" />
          </path>
        </svg>
        <span className="text-sm">加载默认画板…</span>
      </div>
    );
  if (state === 'no_default')
    return (
      <div className="h-full w-full flex items-center justify-center bg-neutral-900 text-white/85 p-8">
        <div className="max-w-sm text-center">
          <p className="text-base font-medium mb-1">暂无可用画板</p>
          <p className="text-sm text-neutral-400">请管理员登录后在 /admin 创建并设置默认画板。</p>
        </div>
      </div>
    );
  return (
    <div className="h-full w-full flex items-center justify-center bg-neutral-900 text-white/85 p-8">
      <p className="text-sm">加载失败，请重试。</p>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <FeedbackEntry />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/b/:slug"
          element={
            <AuthGuard>
              <Board />
            </AuthGuard>
          }
        />
        <Route
          path="/admin"
          element={
            <AuthGuard adminOnly>
              <Admin />
            </AuthGuard>
          }
        />
        <Route
          path="/"
          element={
            <AuthGuard>
              <DefaultBoardRedirect />
            </AuthGuard>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
